export interface SnVerkadaCamera {
  cameraId: string; // eg: "05231f92-643d-4b93-9472-72b8b2fbdb3a"
  cloudRetention: number; // eg: 0
  dateAdded: number; // eg: 1749241920
  deviceRetention: number; // eg: 30
  firmware: string; // eg: "Up to date v2025.06.11.712009-delorean-5mp-secure"
  firmwareUpdateSchedule: string; // eg: "0,86400"
  lastOnline: number; // eg: 1753225166
  localIp: string; // eg: "10.19.144.24"
  location: string; // eg: "134 S Claremont St, San Mateo, CA 94401, USA"
  locationAngle: number; // eg: 0.0
  locationLat: number; // eg: 37.56733699999999
  locationLon: number; // eg: -122.322026
  mac: string; // eg: "E0:A7:00:8C:29:EF"
  model: string; // eg: "CD53-E"
  name: string; // eg: "CD53-E"
  peopleHistoryEnabled: boolean; // eg: true
  serial: string; // eg: "WH3J-FAMQ-K9X7"
  site: string; // eg: "Parking Lot"
  siteId: string; // eg: "59130779-a8b0-4ea5-87f6-b74215b32447"
  status: string; // eg: "Live"
  timezone: string; // eg: "America/Los_Angeles"
  vehicleHistoryEnabled: boolean; // eg: true
}

export interface SnVerkadaPresenceDataParams {
  pageSize?: number;
  pageToken?: string;
}

export interface SnVerkadaPresenceResponse {
  nextPageToken: string | null;
  cameras: SnVerkadaCamera[];
}

export interface SnVerkadaStreamResponse {
  url: string;
  expiresAt: string; // eg: 2025-07-30T22:14:50Z
}

export interface SnVerkadaStreamParams {
  cameraId: string;
  startTime?: number;
  endTime?: number;
  code?: 'hevc' | 'h264';
}

export interface SnVerkadaClipParams {
  cameraId: string;
  startTime: number;
  endTime: number;
}
